import { render, staticRenderFns } from "./DoubleArrowIcon.vue?vue&type=template&id=952c6276&"
import script from "./DoubleArrowIcon.vue?vue&type=script&lang=js&"
export * from "./DoubleArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports